// extracted by mini-css-extract-plugin
module.exports = {"Container":"Switch_Container__1A3cW","Switch":"Switch_Switch__2yLyw","Slider":"Switch_Slider__H-yGo"};